import { MappableModel } from './mappable-model'

import { Logo } from './logo'

export const DEFAULT_TIMEZONE = 'America/New_York'

export class Organization extends MappableModel {
  public email: string
  public guid: string
  public id: number
  public logo: Logo
  public name: string
  public phone: string
  public slug: string
  public timezone: string
  public website_url: string

  public constructor(data: any) {
    super({ ...data, timezone: data.timezone || DEFAULT_TIMEZONE })
  }

  public get timezoneOrDefault(): string {
    return this.timezone || DEFAULT_TIMEZONE
  }
}
